// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hPuW","largestCol":"styles_largestCol__2rBN8","smallestCol":"styles_smallestCol__1VCCG"};